import * as React from 'react'
import { Result } from 'antd'
import Certificate from '../../shared/types'

export const MainPagePayed: React.FC<{ certificate: Certificate }> = ({ certificate }) => {
    if (certificate.completion_text == '') {
        certificate.completion_text = 'Заказ оплачен'
    }
    if (certificate.completion_text_detail == '') {
        certificate.completion_text_detail =
            'На указанный адрес было отправлень письмо бла бла бла (нет параметра в ответе)'
    }
    return (
        <Result
            status="success"
            title={certificate.completion_text}
            subTitle={certificate.completion_text_detail}
            extra={[<></>]}
        />
    )
}
